<template>
	<option :value="id" :selected="selected">{{name}}</option>
</template>

<script>
	export default {
		props: ['id', 'name', 'selected'],
	}
</script>
